import { IGetBetsPositionResponse } from '../../../../repositories/auction/v1/get-bets-position';
import { IGetBetPositionSuccessPayload } from '../types';
import { mapBetsByServices } from './mapBetsByServices';
import { defaultTo } from 'lodash';
import { mapCompetitions } from './mapCompetitions';

export function mapSuccessResponse(response: IGetBetsPositionResponse): IGetBetPositionSuccessPayload {
  return {
    betPositionByService: mapBetsByServices(defaultTo(response.betsByServices, {})),
    competitors: mapCompetitions(defaultTo(response.competitionByPromotions, [])),
  };
}
